import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=652958ec&scoped=true"
import script from "./customerService.vue?vue&type=script&lang=js"
export * from "./customerService.vue?vue&type=script&lang=js"
import style0 from "./customerService.vue?vue&type=style&index=0&id=652958ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652958ec",
  null
  
)

export default component.exports